export function isNode(){
	return typeof module !== 'undefined'
		&& module.exports
		? true
		: false;
}
export default isNode;